const configuration = {
  apiURL: 'http://localhost:3000/v1',
  cdnAddress: 'http://localhost:8090'
};

export default Object.seal(configuration);